module.exports = __webpack_public_path__ + "fonts/font.826ee4e.woff2";